// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 0 !important;
}

.content {
  padding: 1rem;
  margin-bottom: 1rem;
}

.confirm-message {
  margin: 0 0 8px;
}

.confirm-hint {
  margin: 0;
  color: #666;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/confirmation-dialog/confirmation-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,SAAA;EACA,WAAA;EACA,kBAAA;AACF","sourcesContent":[":host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  border-radius: 0 !important;\n}\n\n.content {\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.confirm-message {\n  margin: 0 0 8px;\n}\n\n.confirm-hint {\n  margin: 0;\n  color: #666;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
